import { FC } from 'react';
import { Box } from '@material-ui/core';
import { UI_PADDING } from 'src/globals';
import ScrollToTop from 'src/components/interact/ScrollToTop';
import Scrollbar from 'src/components/layout/Scrollbar';
import Footer from 'src/components/Footer';
import PropTypes from 'prop-types';

const ContentBox: FC<{
  children: any;
  scrollRef: any;
  contentRef: any;
  isBottom?: boolean;
  hasFooter?: boolean;
}> = ({
  children,
  scrollRef,
  contentRef,
  isBottom,
  hasFooter
}) => (
  <Box
    sx={{
      width: '100%',
      height: '100%'
    }}
  >
    <ScrollToTop
      comp={scrollRef}
      isBottom={isBottom}
    />
    <Scrollbar
      options={{ suppressScrollX: true }}
      style={{
        width: '100%',
        height: '100%'
      }}
      id="InfiniteScrollDiv"
      ref={scrollRef}
    >
      <Box>
        <Box
          sx={{
            px: UI_PADDING,
            minHeight: 'calc(100vh - 500px)',
            pt: 2,
            pb: 6
          }}
          ref={contentRef}
        >
          {children}
        </Box>
        {hasFooter && <Footer />}
      </Box>
    </Scrollbar>
  </Box>
);

ContentBox.propTypes = {
  children: PropTypes.any,
  scrollRef: PropTypes.any,
  contentRef: PropTypes.any,
  isBottom: PropTypes.bool,
  hasFooter: PropTypes.bool
};

export default ContentBox;
